<script setup>
import { useI18n } from "vue-i18n";
const { t, tm } = useI18n();

import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { onBeforeUnmount, onMounted, ref } from "vue";

const isSmallScreen = ref(window.innerWidth <= 922);

const updateScreenSize = () => {
  isSmallScreen.value = window.innerWidth <= 922;
};

onMounted(() => {
  window.addEventListener("resize", updateScreenSize);
  updateScreenSize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateScreenSize);
});

const modules = [Pagination];
</script>
<template>
  <div class="wrapper">
    <div class="container">
      <h2 id="mainTitle">{{ t("sectionTwo.headline") }}</h2>
      <swiper
        v-if="isSmallScreen"
        :spaceBetween="20"
        :slidesPerView="1"
        :pagination="{ clickable: true }"
        :modules="modules"
        class="swiper-wrapper"
      >
        <swiper-slide
          class="steps-swiper-slide"
          v-for="(step, key) in tm('sectionTwo.steps')"
          :key="key"
        >
          <div class="step-card-slide">
            <div v-if="step.type === 'placeOrder'" class="vectors-container">
              <img class="cross firstCross" src="../assets/icons/Cross.svg" alt="">
              <img class="cross secondCross" src="../assets/icons/Cross.svg" alt="">
              <img class="cross thirdCross" src="../assets/icons/Cross.svg" alt="">
              <img class="firstVector" src="../assets/icons/Vector_7.svg" alt="">
              <img class="secondVector" src="../assets/icons/Vector_8.svg" alt="">
              <img class="thirdVector" src="../assets/icons/Vector_8.svg" alt="">
            </div>
            <div v-if="step.type === 'getYourMinute'" class="vectors-container">
              <img class="cross firstCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="cross secondCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="cross thirdCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="cross fourthCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="firstVector-min" src="../assets/icons/Vector_5.svg" alt="">
              <img class="secondVector-min" src="../assets/icons/Vector_6.svg" alt="">
              <img class="thirdVector-min" src="../assets/icons/Vector_8.svg" alt="">
              <img class="fourthVector-min" src="../assets/icons/Vector_7.svg" alt="">
              <img class="min-68 " src="../assets/icons/minute-68.svg" alt="" />
              <img class="min-12" src="../assets/icons/minute-12.svg" alt=""/>
              <img class="min-90" src="../assets/icons/minute-90.svg" alt=""/>
              <img class="min-71" src="../assets/icons/minute-71.svg" alt=""/>
            </div>
            <h2 class="title" v-html="step.title"></h2>
            <p class="description" v-html="step.description"></p>
            <div class="step-img">
              <img :src="require(`../assets/img/${step.img}`)" class="img" alt=""/>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div v-else class="steps-wrapper">
        <div v-for="(step, key) in tm('sectionTwo.steps')" :key="key">
          <div class="step-card">
            <div v-if="step.type === 'placeOrder'" class="vectors-container">
              <img class="cross firstCross" src="../assets/icons/Cross.svg" alt="">
              <img class="cross secondCross" src="../assets/icons/Cross.svg" alt="">
              <img class="cross thirdCross" src="../assets/icons/Cross.svg" alt="">
              <img  class="firstVector" src="../assets/icons/Vector_7.svg" alt="">
              <img class="secondVector" src="../assets/icons/Vector_8.svg" alt="">
              <img class="thirdVector" src="../assets/icons/Vector_8.svg" alt="">
            </div>
            <div v-if="step.type === 'getYourMinute'" class="vectors-container">
              <img class="cross firstCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="cross secondCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="cross thirdCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="cross fourthCross-min" src="../assets/icons/Cross.svg" alt="">
              <img class="firstVector-min" src="../assets/icons/Vector_6.svg" alt="">
              <img class="secondVector-min" src="../assets/icons/Vector_6.svg" alt="">
              <img class="thirdVector-min" src="../assets/icons/Vector_8.svg" alt="">
              <img class="fourthVector-min" src="../assets/icons/Vector_7.svg" alt="">
              <img class="min-68 " src="../assets/icons/minute-68.svg" alt="" />
              <img class="min-12" src="../assets/icons/minute-12.svg" alt=""/>
              <img class="min-90" src="../assets/icons/minute-90.svg" alt=""/>
              <img class="min-71" src="../assets/icons/minute-71.svg" alt=""/>
            </div>
            <h3 class="title" v-html="step.title"></h3>
            <p class="description" v-html="step.description"></p>
            <div>
            <img :src="require(`../assets/img/${step.img}`)" class="img" />
            </div>
          </div>
        </div>
      </div>
      <a :href="t('cta.orderNowLink')" target="_blank" class="btn-orderNow-dark">{{ t("cta.orderNow") }}</a>
      <p class="smallPrint">{{ t("sectionTwo.smallPrint") }}</p>
    </div>
  </div>
</template>
<style scoped>
.wrapper {
  background: #eeedea;
}
.vectors-container {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.step-img{
  margin-bottom: 0;
  max-width: 366px;
  max-height: 171px;
}

.step-img img {
  width: 100%;
  height: 100%;
}

.steps-swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.container {
  margin: 0 auto;
  padding-bottom: 30px;
  max-width: 1280px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

#mainTitle {
  font-size: 58px;
  font-weight: 800;
  line-height: 67px;
  color: #000000;
  margin-top: 50px;
}

h3 {
  font-size: 27px;
  font-weight: 900;
  line-height: 27px;
  text-align: center;
}

p {
  font-size: 12px;
  line-height: 17px;
  text-align: center;
}

.smallPrint {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  padding: 30px;
  margin: 0 auto;
}

.description {
  width: 254px;
  text-wrap: pretty;
  z-index: 2;
}

.title {
  margin-top: 65px;
  margin-bottom: 10px;
  width: 273px;
  text-wrap: pretty;
  z-index: 2;
}

.steps-wrapper {
  width: 100%;
}

.steps-wrapper {
  display: flex;
  gap: 15px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.step-card,
.step-card-slide {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 330px;
  height: 424px;
  border-radius: 10px;
  background: url("../assets/img/background.png") no-repeat center center /
    cover;
  overflow: hidden;
}

.btn-orderNow-dark {
  font-family: 'JETSansVF2', Arial, sans-serif;
  margin: 30px;
  padding: 12px 55px 12px 55px;
  border-radius: 110px;
  color: #fafafa;
  background: #242e30;
  font-size: 32px;
  font-weight: 800;
  font-style: italic;
  text-decoration: none;
}

/* Card Icons */
.cross {
  position: absolute;
  width: 22.07px;
  height: 22.07px;
  z-index: 1;
  border: 6px solid transparent;
}

.firstVector {
  width: 276px;
  height: 104px;
  top: 18px;
  left: 54.5px;
  border: 2.18px solid transparent;
  position: absolute;
  z-index: 1;
}

.secondVector {
  top: 398.84px;
  left: 54.53px;
  border: 2.18px solid transparent;
  position: absolute;
  z-index: 1;
}

.thirdVector {
  width: 110.92px;
  height: 248.58px;
  top: 282px;
  left: 110px;
  border: 2.18px solid transparent;
  transform: rotate(-74.94deg);
  position: absolute;
  z-index: 1;
}

.firstCross {
  top: 30.44px;
  left: 40.5px;
}

.secondCross {
  top: 375px;
  left: 43.5px;
}

.thirdCross {
  top: 364.15px;
  left: 278.6px;
  rotate: -34.94deg;
}

.firstCross-min{
  top: 170px;
  left: 25px;
  transform: rotate(-166deg);
}

.secondCross-min{
  top:380px;
  left:73px;
  transform: rotate(8deg);
}

.thirdCross-min{
  top: 195px;
  left:260px;
  transform: rotate(-90deg);
}


.fourthCross-min{
  top:345px;
  left: 270px;
  transform: rotate(16deg);
}

.firstVector-min{
  position: absolute;
  width: 200.36px;
  height: 230.6px;
  top: -50.43px;
  left: -1px;
  border: 2.15px solid transparent;
  transform: rotate(-300.72deg);
}


.secondVector-min {
  position: absolute;
  width: 102.79px;
  height: 168.04px;
  top: 220.78px;
  left: -18px;
  border: 2.15px solid transparent;
  transform: rotate(7.72deg);
}

.thirdVector-min {
  position: absolute;
  width: 117.79px;
  height: 101.04px;
  top: 225.78px;
  left: 219px;
  border: 2.15px solid transparent;
  transform: rotate(160deg);
}

.fourthVector-min {
  position: absolute;
  width: 216.04px;
  height: 175.35px;
  top: 317px;
  left: 70.23px;
  border: 2.15px solid transparent;
  transform: rotate(150deg);
}


.min-12{
  width: 32px;
  height: 18px;
  top: 290px;
  left: 10.18px;
  position: absolute;
}

.min-68{
  width: 37px;
  height: 18px;
  top: 270.43px;
  left: 50.28px;
  position: absolute;
}

.min-90{
  width: 38px;
  height: 18px;
  top: 270.43px;
  left: 240.05px;
  position: absolute;
}

.min-71 {
  width: 31px;
  height: 18px;
  top: 290px;
  left: 288.89px;
  position: absolute;
}

/* Swiper Pagination */

:deep(.swiper-pagination) {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  position: relative;
  gap: 2px;
}

:deep(.swiper-pagination-bullet) {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  border: 2px solid #000000;
  transition: background-color 0.3s;
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #000000;
}

@media (max-width: 768px) {
  .container {
    gap: 10px;
  }

  .step-img{
    margin-bottom: 0;
    max-width: 274px;
    max-height: 159px;
  }

  .step-img img {
    width: 100%;
    height: 100%;
  }

  #mainTitle {
    font-size: 24px;
    line-height: 26px;
    font-weight: 800;
    margin-bottom: 20px;
  }

  .title {
    font-size: 18px;
    line-height: 20px;
    width: 200px;
    margin-top: 50px;
  }

  .description {
    font-size: 9px;
    line-height: 12px;
    width: 180px;
  }

  .smallPrint {
    font-size: 10px;
    line-height: 9px;
    text-align: center;
    max-width: 276px;
    padding: 5px;
  }

  .step-card,
  .step-card-slide {
    width: 247px;
    height: 318px;
    border-radius: 7px;
  }

  .btn-orderNow-dark {
    padding: 10px 53px 10px 53px;
    font-size: 24px;
    margin: 10px;
  }

  /* Icons */
  .cross {
    position: absolute;
    width: 16px;
    height: 16px;
    z-index: 1;
    border: 5px solid transparent;
  }

  .firstVector {
    width: 207px;
    height: 78px;
    top: 13px;
    left: 40px;
    border: 1.63px solid transparent;
    position: absolute;
    z-index: 1;
  }

  .secondVector {
    width: 60.99px;
    height: 73px;
    top: 264.84px;
    left: 25.53px;
    border: 1.63px solid transparent;
    position: absolute;
    z-index: 1;
  }

  .thirdVector {
    width: 60.92px;
    height: 73.58px;
    top: 280px;
    left: 189px;
    border: 2.18px solid transparent;
    transform: rotate(65deg);
    position: absolute;
    z-index: 1;
  }

  .firstCross {
    top: 22px;
    left: 24px;
  }

  .secondCross {
    top: 278px;
    left: 15.5px;
  }

  .thirdCross {
    top: 274px;
    left: 208px;
    rotate: -34.94deg;
  }

  .firstCross-min{
    top: 138px;
    left: 14px;
    transform: rotate(-166deg);
  }

  .secondCross-min{
    top:290px;
    left:50px;
    transform: rotate(8deg);
  }

  .thirdCross-min{
    top: 150px;
    left:210px;
    transform: rotate(-90deg);
  }


  .fourthCross-min{
    top:274px;
    left: 200px;
    transform: rotate(16deg);
  }

  .firstVector-min{
    position: absolute;
    width: 140.02px;
    height: 172.95px;
    top: -5.42px;
    left: -11px;
    border: 1.61px solid transparent;
    transform:rotate(-228.72deg);
  }


  .secondVector-min {
    position: absolute;
    width: 115.09px;
    height: 126.03px;
    top: 170.84px;
    left: -40.75px;
    border: 1.61px solid transparent;
    transform:rotate(363deg);
    z-index: 1;

  }

  .thirdVector-min {
    position: absolute;
    width: 120.79px;
    height: 131.04px;
    top: 285px;
    left: 170px;
    border: 1.61px solid transparent;
    transform: rotate(48deg);
    z-index: 1;

  }

  .fourthVector-min {
    position: absolute;
    width: 133.09px;
    height: 75.98px;
    top: 180.32px;
    left: 177.06px;
    border: 1.61px solid transparent;
    transform: rotate(54deg);
  }


  .min-12{
    width: 24px;
    height: 12px;
    top: 235px;
    left: 18.18px;
    position: absolute;
  }

  .min-68{
    width: 28px;
    height: 14px;
    top: 210.43px;
    left: 33.28px;
    position: absolute;
  }

  .min-90{
    width: 28px;
    height: 14px;
    top: 209.43px;
    left: 192.05px;
    position: absolute;
  }

  .min-71 {
    width: 23px;
    height: 14px;
    top: 232px;
    left: 212.89px;
    position: absolute;
  }
}
</style>
